import { apiV2 } from '../axios';

// Callers handle errors; the gateway puts the reason in err.response.data.message.
export const getTransferRecipient = async (email) =>
	(await apiV2.get('/transfer/recipient', { params: { email } })).data;

export const createTransfer = async (childId, email) =>
	(await apiV2.post('/transfer', { childId, email })).data;

export const getTransfers = async () => (await apiV2.get('/transfer')).data;

export const acceptTransfer = async (id) =>
	(await apiV2.post(`/transfer/${id}/accept`)).data;

export const declineTransfer = async (id) =>
	(await apiV2.post(`/transfer/${id}/decline`)).data;

export const cancelTransfer = async (id) =>
	(await apiV2.post(`/transfer/${id}/cancel`)).data;

// apiV2 moves `pass` into the Authorization-Verify header, which release requires.
export const releaseTransfer = async (id, pass) =>
	(await apiV2.post(`/transfer/${id}/release`, { pass })).data;
